export const DeviceUserPrivilegesEditSceneTranslation = {
  fi: {
    DeviceUserPrivilegesEditScene: {
      title: 'Muokkaa käyttäjän oikeuksia',
      hasBasicAccess: 'Perusoikeudet',
      hasDistributionAccess: 'Jakeluoikeudet',
    },
  },
};
